export var triggerTopmail = function triggerTopmail(option) {
  var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (debug) {
    window.console.info("TopMail.Ru: ".concat(option.id, " ").concat(option.type, " ").concat(option.goal || ''));
    return;
  }

  if (typeof window !== 'undefined' && typeof window._tmr !== 'undefined') {
    var options = {
      id: option.id,
      referrer: option.referrer,
      start: new Date().getTime(),
      type: option.type,
      url: option.url,
      userid: option.userid
    };

    if (option.goal) {
      options.goal = option.goal;
    }

    window._tmr.push(options);
  }
};